import * as toastr from 'toastr';
import { OBTER_IPI_CF } from '../actions/index';

export default function (state = {}, action) {
    switch (action.type) {
        case OBTER_IPI_CF:                
            if(action.error){
                toastr.error("Erro obtendo classificações.");
                return state;                
            }else{           
                return action.payload;
            }
        default:
            return state;
    }   
}
